// extracted by mini-css-extract-plugin
module.exports = {"input":"ForgotPassword_input__1snpg","instructions":"ForgotPassword_instructions__17Ttd"};